var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Theme = /** @class */ (function () {
    function Theme() {
        this.Colors = {
            primary: null,
            secondary: null,
            accent: null,
        };
        this.Breakpoints = {
            MobileMax: 500,
            XsMin: 501,
            XsMax: 699,
            SmMin: 700,
            SmMax: 1099,
            MdMin: 1100,
            MdMax: 1439,
            LgMin: 1440,
            LgMax: 1799,
            XlMin: 1800,
        };
        this.ButtonProps = {
            base: {},
            action: {},
            error: {},
            cancel: {},
        };
        this.TextInputProps = {};
        this.TextAreaInputProps = {};
    }
    return Theme;
}());
export { Theme };
var ThemeEditor = /** @class */ (function () {
    function ThemeEditor(theme) {
        this.theme = theme;
    }
    Object.defineProperty(ThemeEditor.prototype, "current", {
        get: function () { return this.theme; },
        enumerable: false,
        configurable: true
    });
    ThemeEditor.prototype.setColors = function (colors) {
        for (var _i = 0, _a = Object.keys(colors); _i < _a.length; _i++) {
            var key = _a[_i];
            var color = colors[key];
            document.documentElement.style.setProperty("--".concat(key), "".concat(color));
        }
    };
    ThemeEditor.prototype.setBreakpoints = function (props) { this.theme.Breakpoints = __assign(__assign({}, this.theme.Breakpoints), props); };
    ThemeEditor.prototype.setButtonProps = function (props) { this.theme.ButtonProps = props; };
    ThemeEditor.prototype.setTextAreaInputProps = function (props) { this.theme.TextAreaInputProps = props; };
    ThemeEditor.prototype.setTextInputProps = function (props) { this.theme.TextInputProps = props; };
    return ThemeEditor;
}());
export { ThemeEditor };
var themeData = new Theme();
export var theme = new ThemeEditor(themeData);
